export default "__VITE_ASSET__1e5db3e2__"